module.exports = __webpack_public_path__ + "static/uni_hampton-fea40acbfc97eb2b26f1bebc1604845c.png";